<template>
  <div
    class="codes-tree-item"
    :class="isDisabled ? 'is-disabled' : ''"
  >
    <template v-if="!isDisabled">
      <template v-if="isPartialMode">
        <PsQuadbox
          :state="checkedState"
          @change="onChange($event)"
        />
      </template>
      <template v-else>
        <PsCheckbox
          :checked="checkedState"
          :checkedValue="EQuadboxState.included"
          :uncheckedValue="EQuadboxState.unchecked"
          @update:checked="onChange($event as EQuadboxState)"
        />
      </template>
    </template>
    <span
      v-if="item.name"
      :title="path"
      class="item-title"
      @click="onTitleClick"
    >
      {{ item.name || path }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import PsCheckbox from '@/ContextTab/components/UI/PsCheckbox.vue'
import PsQuadbox from '@/ContextTab/components/UI/PsQuadbox.vue'
import { EQuadboxState, nextQuadboxState } from '@/ContextTab/components/UI/types'
import { formatCodePath } from '@/lib/codes'
import type {
  CodeSelectState,
  CodeSelectMode,
  CodeTreeSelectEvent,
} from '@/ContextTab/modules/news/codes/types'
import type { CodeWithCategoryAndChildren } from '@/api/generated/v2'


const props = defineProps<{
  item: CodeWithCategoryAndChildren
  selectMode: CodeSelectMode
  selectState: CodeSelectState
  disabled?: number[]
}>()

const emit = defineEmits<{
  (e: 'change', payload: CodeTreeSelectEvent): void
}>()

const path = computed(() => formatCodePath(props.item.path))

const isDisabled = computed(() => !!props.disabled?.includes(props.item.id))

const isPartialMode = computed(() => props.selectMode === 'partial')

const checkedState = computed(() => props.selectState[props.item.id] ?? EQuadboxState.unchecked)

function onChange(state: EQuadboxState) {
  emit('change', { id: props.item.id, state })
}

function onTitleClick() {
  if (!isDisabled.value) {
    onChange(nextQuadboxState(checkedState.value, !isPartialMode.value))
  }
}
</script>

<style scoped>
.codes-tree-item {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  gap: 0.25rem;
  min-height: 24px;
  padding: 2px 0;
  vertical-align: middle;

  .item-title {
    display: inline-block;
    cursor: pointer;
  }

  &.is-disabled {
    .item-title {
      cursor: default;
    }
  }
}
</style>
